import { IUser } from '@novakid/ts-types';

import { CONFIG } from 'config';

/**
 *
 * @description inject bloomreach script directly without GTM initialisation - we need this for
 * users from RU region
 */
export function injectBloomreach(user: IUser) {
  if (!user) return;

  const isParent = user.group === 'users';
  const isTeacher = user.group === 'teachers';

  if (!isParent && !isTeacher) {
    console.warn('Unknown user group:', user.group);
    return;
  }

  const token = isParent ? CONFIG.BLR_PARENT_KEY : CONFIG.BLR_TEACHER_KEY;

  const customer = isParent ? `parent_${user.id}` : { email: user.email };

  const params: Record<string, any> = {
    target: 'https://bloomreach.novakidschool.com',
    token,
    customer,
    track: { google_analytics: false },
    ...(isTeacher && {
      experimental: { non_personalized_weblayers: true },
    }),
  };

  fetch('/bloomreach-template.tpl')
    .then((res) => res.text())
    .then((template) => {
      const filled = template.replace('__PARAMS__', JSON.stringify(params));

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.text = filled;
      script.id = 'bloomreach-script';

      document.head.appendChild(script);
    })
    .catch((err) => {
      console.error('Failed to load Bloomreach template:', err);
    });
}
